/**
 * Centralizes asset-lineage classification so every asset view applies the
 * same presentation policy without depending on UI or localization modules.
 */

const AUTOGEN_METHODS = new Set([
  'smart-crop',
  'naive-crop',
  'html-template',
]);

export type AssetSourceLabel = 'AUTOGEN' | 'BOX' | 'VAULT';

export function deriveAssetSourceLabel (
  generationMethods?: string[],
): AssetSourceLabel | null {
  const methods = generationMethods ?? [];

  if (methods.some((method) => AUTOGEN_METHODS.has(method))) return 'AUTOGEN';
  if (methods.includes('box')) return 'BOX';
  if (methods.includes('vault')) return 'VAULT';

  return null;
}
